export default __webpack_public_path__ + "static/media/2.e8f4fff3.jpg";